<template lang="html">
  <li class="project-list-item">
    <AppLink
      :is-link="project && project.url"
      :to="project.url"
    >
      <div class="project-list-item__content">
        <h3 v-if="project.columns.teaser" class="project-list-item__headline">
          <u class="project-list-item__headline-underline">{{ project.columns.teaser.title }}</u>
          <span
            v-if="project.hasVideo"
            :class="`project-list-item__video-label--${colorClass}`"
            class="project-list-item__video-label"
          >
            VIDEO
          </span>
        </h3>
        <div class="project-list-item__tags">
          <span
            :class="[
              'project-list-item__focus',
              `project-list-item__focus--${colorClass}`
            ]"
          >
            {{ project.columns.focus }}
          </span>
          <span class="project-list-item__date">
            {{ project.columns.projectStarted }}
          </span>
        </div>
        <div
          v-if="hasVideo"
          :class="`project-list-item__video-indicator--${colorClass}`"
          class="project-list-item__video-indicator"
        />
      </div>
    </AppLink>
  </li>
</template>

<script>
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    AppLink
  },
  props: {
    project: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    colorClass () {
      return this.project.columns.focus && this.project.columns.focus.toLowerCase()
    },
    hasVideo () {
      return false
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/colors';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/font';
@import 'beisheim/scss/grid';
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/line-heights';

$component: '.project-list-item';

#{$component} {
  border-top: 1px solid gray(3);
  transition: background-color 100ms ease-in-out;

  &:hover {
    background-color: gray(4);
  }

  @include from(3) {
    @include grid-spacing(margin-left, 1);
    @include grid-spacing(margin-right, 1);
  }

  &:first-child {
    border-top: none;
  }

  &__content {
    display: flex;
    flex-direction: column;
    @include grid-spacing(padding-left, 2);
    @include grid-spacing(padding-right, 2);
    padding-top: scale(6);
    justify-content: center;
    align-items: center;

    @include from(3) {
      @include grid-spacing(padding-left, 1);
      @include grid-spacing(padding-right, 1);
      padding-bottom: scale(6);
    }

    @include from(4) {
      flex-direction: row;
    }
  }

  &__headline {
    @include font(2);
    line-height: line-height(3);
    margin-bottom: scale(7);

    &-underline {
      text-decoration: none;
      border-bottom: 1px solid gray(1);
    }

    @include from(3) {
      @include font(1.5);
      line-height: line-height(3);
      padding-right: scale(7);
      flex-basis: 62.5%;

      // IE11 Bugfix
      @media all and (-ms-high-contrast:none) {
        flex-basis: auto !important;
        width: 100% !important;
      }

      #{$component} {
        &__headline-underline {
          border-bottom: 0;
        }
      }
    }

    @include from(4) {
      margin-bottom: 0;
    }
  }

  &__tags {
    display: flex;
    justify-content: space-between;
    margin-bottom: scale(6);
    @include font(0.5);

    @include from(3) {
      flex-basis: 37.5%;
      align-items: center;
      margin-bottom: 0;
      @include font(0);
    }

    // IE11 Bugfix
    @media all and (-ms-high-contrast:none) {
      flex-grow: 1;
      flex-shrink: 1;
    }
  }

  &__date {
    flex-basis: 50%;
    white-space: nowrap;

    @include to(3) {
      margin-left: 1rem;
    }

    // IE11 Bugfix
    @media all and (-ms-high-contrast:none) {
      flex-basis: auto !important;
    }
  }

  &__focus {
    flex-basis: 50%;
    white-space: nowrap;

    // IE11 Bugfix
    @media all and (-ms-high-contrast:none) {
      flex-basis: auto !important;
    }

    &::before {
      display: inline-block;
      content: '';
      position: relative;
      top: -#{scale(1)};
      width: scale(3);
      height: scale(3);
      border-radius: 50%;
    }

    @include from(3) {
      &::before {
        top: 0.05rem;
      }
    }

    &--bildung {
      &::before {
        background-color: brand(3);
      }
    }
    &--gesundheit {
      &::before {
        background-color: brand(4);
      }
    }
    &--kultur {
      &::before {
        background-color: brand(1);
      }
    }
    &--sport {
      &::before {
        background-color: brand(2);
      }
    }
    &--neutral {
      &::before {
        background-color: gray(4);
      }
    }
  }

  &__video-label {
    margin-left: 1rem;
    font-size: 0.5em;

    &--bildung {
      color: brand(3);
    }
    &--gesundheit {
      color: brand(4);
    }
    &--kultur {
      color: brand(1);
    }
    &--sport {
      color: brand(2);
    }
  }

  &__video-indicator {
    margin-right: -17.3px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 0 10px 17.3px;
    border-color: transparent transparent transparent #ffffff;

    @include to(3) {
      display: none;
    }

    &--bildung {
      border-color: transparent transparent transparent brand(3);
    }
    &--gesundheit {
      border-color: transparent transparent transparent brand(4);
    }
    &--kultur {
      border-color: transparent transparent transparent brand(1);
    }
    &--sport {
      border-color: transparent transparent transparent brand(2);
    }
  }
}
</style>
